import { useTranslation } from "react-i18next";
import {
  IAppointment,
  ScheduledAppointments,
} from "./Components/ScheduledAppointments";
import { InteractiveWebinars } from "./Components/InteractiveWebinars";
import { useState } from "react";
import { useQuery } from "react-query";
import { GuideDetails } from "../../../@types";
import {
  getUserAppointments,
  getUserGuide,
} from "../../../services/guide.service";

export function Appointments() {
  const { t } = useTranslation("appointments");

  const {
    data: appointmentsData,
    isLoading: isLoadingAppointments,
    error: errorAppointments,
    refetch: refetchAppointments,
  } = useQuery<any, Error>("consultingAppointments", getUserAppointments, {});

  const { data: guide, isLoading } = useQuery<GuideDetails>(
    ["guide"],
    getUserGuide
  );

  return (
    <div className="px-6 pt-4 lg:pt-9 sm:px-9 lg:px-0 flex flex-col w-full h-full items-center">
      <div className="w-full lg:w-5/6 max-w-screen-lg">
        <h1 className="text-Yellow-default text-lg font-semibold">
          {t("page-title")}
        </h1>
        <div className="mb-4 md:mb-5 mt-1">
          {t("description").trim() || null}
        </div>
        <ScheduledAppointments
          appointments={appointmentsData?.combinedAppointments}
          assignedConsultantId={
            appointmentsData?.assignedConsultantId.platformContentId
          }
        />
        <InteractiveWebinars refetchAppointments={refetchAppointments} />
      </div>
    </div>
  );
}
